import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=3356e406&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"
import style0 from "./Department.vue?vue&type=style&index=0&id=3356e406&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3356e406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3356e406')) {
      api.createRecord('3356e406', component.options)
    } else {
      api.reload('3356e406', component.options)
    }
    module.hot.accept("./Department.vue?vue&type=template&id=3356e406&scoped=true", function () {
      api.rerender('3356e406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Asset/Department/Department.vue"
export default component.exports